import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaf776a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HotArticlesList" }
const _hoisted_2 = { class: "HotArticlesList-title" }
const _hoisted_3 = { class: "HotArticlesList-main" }
const _hoisted_4 = { class: "HotArticlesList-main-box" }
const _hoisted_5 = ["onClick"]

import { reactive, onMounted, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { getHotList } from '@/apis/frog'
import { useRtfix, useSite2Station } from '@/store'
import { useRouter } from 'vue-router'
import MemberEventBox from '@/components/common/MemberEventBox.vue'
import { useStore } from 'vuex'
import { confirmLogin } from '@/util/useConfirm'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const token = store.getters.token
const user = computed(() => store.getters.user)

const router = useRouter()
const stationCode = useSite2Station()

onMounted(() => {
  getList()
})

const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 12,
    total: 0
  }
})

// 获取列表
const getList = () => {
  const formData = {
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  getHotList(formData).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data.records
      data.list.sort((a: any, b: any) => {
        return b.viewNum - a.viewNum
      })
      data.page.total = res.data.total
    }
  })
}

// 跳转文章详情
const toArticle = (item: any) => {
  if (!token && item.noLoginRestriction === 3) {
    confirmLogin(async () => {})
    return
  }
  if (item.noMembershipRestriction === 3 && !user?.value?.membership?.templateLevel) {
    store.commit('status/memberDialog', true)
    return
  }
  router.push(useRtfix('article', { params: { id: item.frogArticleId, type: 2 } }))
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('热门文章')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_scrollbar, { height: "100%" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.frogArticleId,
                class: "HotArticlesList-main-item tstn",
                onClick: ($event: any) => (toArticle(item))
              }, [
                _createElementVNode("span", null, _toDisplayString(item.frogArticleTitle), 1)
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _: 1
      }),
      (_unref(data).list.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: _unref(t)('没有更多了')
          }, null, 8, ["description"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})